import { Entity, Field } from "typegraph";

import Lifecycle from "common/entities/Lifecycle";
import EntitySelect from "common/form/fields/entitySelect/EntitySelect";
import DropdownSelect from "common/form/widgets/common/DropdownSelect";
import Label from "core/components/label/Label";

@Entity({one: 'knowledgeBase_one', many: 'knowledgeBase_many'})
class KbIdName {

	@Field()
	public id: any;

	@Field()
	public guid: string;

	@Field()
	public name: string;
}

export const knowledgeBaseGuidSelect = EntitySelect.registered({
	entity: KbIdName,
	type: 'one',
	getValue: (o) => o && o.guid,
	getDefaultValueParams: (guid) => {
		return { guid };
	}
}, 'string');

export const knowledgeBaseIdSelect = EntitySelect.registered({
	entity: KbIdName,
	type: 'one',
	getValue: (o) => o && o.id,
	getDefaultValueParams: (id) => {
		return { id };
	}
}, 'string');

export const articleStatusSelect = DropdownSelect.registerWithOptions([
	{value: Lifecycle.Predeployed, label: <Label k="Lifecycle.Predeployed" v={Lifecycle.Predeployed} />},
	{value: Lifecycle.Published, label: <Label k="Lifecycle.Published" v={Lifecycle.Published} />},
	{value: Lifecycle.Deleted, label: <Label k="Lifecycle.Deleted" v={Lifecycle.Deleted} />}
]);



// WEBPACK FOOTER //
// ./src/panels/kb/util/widget.tsx